/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import item from './in-progress';
import lastImported from './last-imported';

export default combineReducers({
	item,
	lastImported
});
